/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
//
export default new Vuex.Store({
  state: {
    authentication: {},
    nav: false,
    lang: 'kr',
    sv: 0,
    sect: '',
    sdir: 'up',
    chuncheonPopup: null,
    onFix: false,
    popupVideo: null,
    videoBase: '/video',
  },
  mutations: {
    setAuthentication(state, value) {
      state.authentication = value;
    },
    openNav(state) {
      state.nav = true;
    },
    closeNav(state) {
      state.nav = false;
    },
    setLang(state, lang) {
      state.lang = lang || 'kr';
    },
    scroll(state, val) {
      state.sv = val;
    },
    scrollDir(state, val) {
      state.sdir = val;
    },
    section(state, val) {
      state.sect = val;
    },
    setChuncheonPopup(state, value){
      state.chuncheonPopup = value;
    },
    setFix(state, val) {
      state.onFix = val;
    },
    showVideo(state, val) {
      state.popupVideo = val;
    },
    setVideoBase(state, val) {
      state.videoBase = val;
    }
  },
});
